<template>
    <svg
        :width="w"
        :height="h"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid">
        <circle
            cx="50"
            cy="50"
            fill="none"
            stroke-linecap="round"
            r="40"
            stroke-width="5"
            stroke="#039fff"
            stroke-dasharray="62.83185307179586 62.83185307179586"
            transform="rotate(55.897 50 50)">
            <animateTransform
                attributeName="transform"
                type="rotate"
                calcMode="linear"
                values="0 50 50;360 50 50"
                keyTimes="0;1"
                dur="1.5s"
                begin="0s"
                repeatCount="indefinite"
            ></animateTransform>
        </circle>
        <circle
            cx="50"
            cy="50"
            fill="none"
            stroke-linecap="round"
            r="34"
            stroke-width="5"
            stroke="#424245"
            stroke-dasharray="53.40707511102649 53.40707511102649"
            stroke-dashoffset="53.40707511102649"
            transform="rotate(-55.897 50 50)">
            <animateTransform
                attributeName="transform"
                type="rotate"
                calcMode="linear"
                values="0 50 50;-360 50 50"
                keyTimes="0;1"
                dur="1.5s"
                begin="0s"
                repeatCount="indefinite"
            ></animateTransform>
        </circle>
    </svg>
</template>

<script>
    export default {
        name: "spinner",
        props: {
            w: {
                type: Number,
                default: 50
            },
            h: {
                type: Number,
                default: 50
            }
        }
    };
</script>
